export default __webpack_public_path__ + "assets/alvaro-component.6d059c65.svg";